<ng-template #contentTemplate>
    <ng-content></ng-content>
</ng-template>

<div class="d-block d-lg-none">
    <div class="menu-group">
        <app-accordion>
            <ng-container slot="header">
                <span class="group-headline">{{ headline }}</span>
            </ng-container>
            <ng-container slot="content">
                <ul>
                    <li class="menu-item" *ngFor="let link of links; let first = first">
                        <app-link [link]="link">
                            <span [ngClass]="{ 'text-bold': firstLinkBold && first }"> {{ link.name }} </span>
                        </app-link>
                    </li>
                </ul>
            </ng-container>
        </app-accordion>
    </div>
</div>

<div class="d-none d-lg-block">
    <div class="menu-group">
        <h2 class="group-headline">{{ headline }}</h2>
        <ul>
            <li class="menu-item" *ngFor="let link of links; let first = first">
                <app-link [link]="link">
                    <span [ngClass]="{ 'text-bold': firstLinkBold && first }"> {{ link.name }} </span>
                </app-link>
            </li>
        </ul>

        <ng-container *ngTemplateOutlet="contentTemplate"></ng-container>
    </div>
</div>
